import { el } from './dom.js';

let container;

function getContainer() {
  if (!container) {
    container = el('div', { className: 'toast-container' });
    document.body.appendChild(container);
  }
  return container;
}

/**
 * Show a toast notification.
 * @param {string} message
 * @param {{ duration?: number, type?: 'info'|'success'|'error' }} opts
 */
export function showToast(message, { duration = 3000, type = 'info' } = {}) {
  const toast = el('div', { className: `toast toast--${type}` }, message);
  getContainer().appendChild(toast);

  requestAnimationFrame(() => toast.classList.add('toast--visible'));

  setTimeout(() => {
    toast.classList.remove('toast--visible');
    toast.addEventListener('transitionend', () => toast.remove(), { once: true });
    setTimeout(() => { if (toast.parentNode) toast.remove(); }, 300);
  }, duration);
}
